var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.836 27.695c-1.25.2-2.53.305-3.836.305-1.264 0-2.506-.098-3.717-.286.118-1.146.184-2.563.22-3.779-1.806-1.085-3.439-2.904-4.616-4.997C10.394 18.06 8.563 16.689 8 15c-1-3-2-5-2-5s2.11.675 4.012 1.74C10.227 6.308 13.345 2 19.998 2c6.653 0 9.775 4.308 9.99 9.74C31.891 10.674 34 10 34 10s-1 2-2 5c-.563 1.689-2.394 3.061-3.887 3.938-1.167 2.076-2.783 3.882-4.572 4.97.06 1.215.152 2.636.295 3.787zm-10.01 1.568a62.062 62.062 0 0 1-4.858 1.367c-2.765.665-5.121 2.564-6.141 5.22L2 38h36l-.828-2.152c-1.02-2.654-3.375-4.553-6.14-5.218a62.082 62.082 0 0 1-4.86-1.367A26.063 26.063 0 0 1 20 30c-2.127 0-4.195-.256-6.174-.737z",
    fill: "#9A9CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityIcon);
export default __webpack_public_path__ + "static/media/identityIcon.b6e5242f.svg";
export { ForwardRef as ReactComponent };